module.exports = __webpack_public_path__ + "img/DieFerneSoNah.fe8bbb8d.jpg";